import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../shared/models/User';
import { GlobalService } from '../shared/services/global';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})
export class HeaderMenuComponent implements OnInit {

  isExpanded: boolean;
  CurUser: User;  
  IsAdminUser: boolean;
  IsTolomaticUser: boolean;
  HasCurrentUser: boolean;
  DisplayName: string;
  userLocale: string;
  HideNav: boolean;
  constructor(private global:GlobalService,private router:Router,private actRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.HideNav = true;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      if ((!this.CurUser || this.CurUser == null) || (this.actRoute.url[0] == '/')) {
        this.HideNav = true;
      }
      else {
        this.HideNav = false;
        this.IsTolomaticUser = this.CurUser.IsTolomaticUser;
        this.IsAdminUser = this.CurUser.Role.indexOf("manager") >= 0 || this.CurUser.IsTolomaticUser;
      }
    });
    this.global.CurrentUser.subscribe(user => {
      if (user != null) {
        this.CurUser = new User().BuildUser(user);
      } else {
        this.CurUser = user;
      }
      
      this.DoUserCheck();
    });
    
  }

  DoUserCheck() {
    if ((!this.CurUser || this.CurUser == null)) {
      this.HideNav = true;
    }
    else {
      this.HideNav = false;
      this.IsTolomaticUser = this.CurUser.IsTolomaticUser;
      this.IsAdminUser = this.CurUser.Role.indexOf("manager") >= 0 || this.CurUser.IsTolomaticUser;
    }
  }

  LoginBtn_Click() {

  }

  Logout() {
    this.global.setCurrentUser(null);
    this.router.navigate(['./']);
  }

  GetCSSClass(page: string) {
    var classList = "";

    if (this.CurUser == null || (this.CurUser != null && this.CurUser.HasPagePermission && !this.CurUser.IsTolomaticUser && !this.CurUser.HasPagePermission(page))) {
      classList = "hidden ";
      return classList;
    }

    if (this.router.url.indexOf(page) >= 0) {
      classList = classList + "current";
    }
    else {
      classList = classList + "";
    }

    return classList;
  }


  EditProfile() {
    if (this.CurUser) {
      this.router.navigateByUrl('/edituser', { state: { User: this.CurUser, type: "edit", redirectURL:"/" } });
    }
  }
}
